import React, { useContext } from "react";
import { DataComplaintContext } from "../types";
import { InputElement } from "../../../HtmlComponents/InputElement";
import { useTranslation } from "react-i18next";
import { InputImage } from "../../../HtmlComponents/InputImage";
import { hostName } from "../../../requestMethods";
import { TextAreaElement } from "../../../HtmlComponents/TextAreaElement";

const InputsComplaint: React.FC = () => {
  const {
    fullName, setFullName,
    phone, setPhone,
    RegNo, setRegNo,
    cabinetName, setCabinetName,
    doctorName, setDoctorName,
    devis, setDevis,
    message, setMessage,
  } = useContext(DataComplaintContext);
  const { t } = useTranslation()

  return (<>
    <InputElement
      type="text"
      name={t("Nom")}
      placeholder="Nom du patient"
      id="fullName"
      value={fullName}
      setValue={setFullName}
    />
    <InputElement
      type="text"
      name={t("Telephone")}
      id="Telephone"
      value={phone}
      setValue={setPhone}
    />
    <InputElement
      type="text"
      name={t("Matricule")}
      id="Matricule"
      value={RegNo}
      setValue={setRegNo}
    />
    <InputElement
      type="text"
      name={t("Cabinet")}
      placeholder={t("Nom du Cabinet")}
      id="Cabinet"
      value={cabinetName}
      setValue={setCabinetName}
    />
    <InputElement
      type="text"
      name={t("Docteur")}
      placeholder={t("Nom du Docteur")}
      id="Docteur"
      value={doctorName}
      setValue={setDoctorName}
    />
    <TextAreaElement
      name={t("Plainte")}
      placeholder={t("Ecrivez-vous votre plainte envers ce docteur")}
      id="Plainte"
      value={message}
      setValue={setMessage}
    />
    <InputImage name="Devis" setValue={setDevis}/>
    {(devis && (typeof devis === 'string')) && <img className='w-full h-56 col-span-2' src={hostName + "imgs/complaints/" + devis} alt="devisAss" /> }          
    {(devis && (typeof devis !== 'string')) && <img className='w-full h-56 col-span-2' src={URL.createObjectURL(devis)} alt="devisAss" /> }          
  </>);
};

export default InputsComplaint;
